module.exports = __webpack_public_path__ + "static/media/3be982f2-5908-438b-a5bb-38bbe7ad668d.33276558.png";